import {useMemo} from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAiGeneratedTemplateByEdition as GetAiGeneratedTemplateByEditionQuery,
    GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet as AiGeneratedTemplate,
    GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions_edges_node as AiGeneratedEdition,
    GetAiGeneratedTemplateByEditionVariables,
} from 'nutshell-graphql-types';

import GET_AI_GENERATED_TEMPLATE_BY_EDITION from '../queries/get-ai-generated-template-by-edition.graphql';

export const useGetAiGeneratedTemplateByEdition = (
    editionId: string
): {
    aiGeneratedTemplate: AiGeneratedTemplate | null | undefined;
    editions: AiGeneratedEdition[];
    isAnyGenerating: boolean;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAiGeneratedTemplateByEditionQuery,
        GetAiGeneratedTemplateByEditionVariables
    >(GET_AI_GENERATED_TEMPLATE_BY_EDITION, {
        variables: {
            editionId,
        },
        fetchPolicy: 'cache-and-network',
    });

    const aiGeneratedTemplate = data?.aiGeneratedTemplateGet;
    const editions = useMemo(
        () => aiGeneratedTemplate?.editions.edges.map((edge) => edge.node) ?? [],
        [aiGeneratedTemplate?.editions.edges]
    );
    const isAnyGenerating = editions.some((edition) => edition.status === 'GENERATING');

    return {
        aiGeneratedTemplate,
        editions,
        isAnyGenerating,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
